import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonAdd = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M21 6H20V5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5V6H17C16.4477 6 16 6.44772 16 7C16 7.55228 16.4477 8 17 8H18V9C18 9.55228 18.4477 10 19 10C19.5523 10 20 9.55228 20 9V8H21C21.5523 8 22 7.55228 22 7C22 6.44772 21.5523 6 21 6Z" }),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14 7C14 9.20914 12.2091 11 10 11C7.79086 11 6 9.20914 6 7C6 4.79086 7.79086 3 10 3C12.2091 3 14 4.79086 14 7ZM12 7C12 5.89543 11.1046 5 10 5C8.89543 5 8 5.89543 8 7C8 8.10457 8.89543 9 10 9C11.1046 9 12 8.10457 12 7Z"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M10 13C6.13401 13 3 16.134 3 20C3 20.5523 3.44772 21 4 21C4.55228 21 5 20.5523 5 20C5 17.2386 7.23858 15 10 15C12.7614 15 15 17.2386 15 20C15 20.5523 15.4477 21 16 21C16.5523 21 17 20.5523 17 20C17 16.134 13.866 13 10 13V13Z" })
		]
	})
});
export { SvgPersonAdd as ReactComponent };
